module.exports = __webpack_public_path__ + "assets/img/DP_Icon_Blk.22e6b7f2.png";